document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-multi-size-order-form]').forEach((form) => {
    const variantData = form.querySelector('[data-multi-size-variants]');
    const colorInputs = form.querySelectorAll('[data-multi-size-color]');
    const sizeRows = form.querySelectorAll('[data-multi-size-row]');
    const addToCartButton = form
      .closest('form')
      ?.querySelector('[data-multi-size-atc]');

    if (!variantData || !sizeRows.length) return;

    const variants = JSON.parse(variantData.textContent);

    const updateSizes = (color) => {
      sizeRows.forEach((row) => {
        const size = row.dataset.sizeValue;
        const quantity = row.querySelector('[data-multi-size-quantity]');
        const minusButton = row.querySelector('[data-multi-size-minus]');
        const plusButton = row.querySelector('[data-multi-size-plus]');
        const quantityControl = row.querySelector('.multi-size-order-form__quantity-control');
        const notifyButton = row.querySelector('[data-multi-size-notify]');
        const colorLabel = row.querySelector('[data-multi-size-row-color]');

        const inventoryLabel = row.querySelector('[data-multi-size-inventory]');
        const priceLabel = row.querySelector('[data-multi-size-price]');    

        if (colorLabel) {
          colorLabel.textContent = color ? `(${color})` : '';
        }

        const variant = variants.find((item) => {
        if (colorInputs.length) {
          return item.option1 === color && item.option2 === size;
        }

  return item.option1 === size;
});

        row.dataset.variantId = variant ? variant.id : '';
        row.hidden = !variant;
        if (notifyButton) {
        notifyButton.dataset.variantId = variant ? variant.id : '';
        }
        if (variant) {
        if (inventoryLabel) {
        inventoryLabel.textContent =
        variant.inventory_quantity > 0
        ? `${variant.inventory_quantity} in stock`
        : 'Out of stock';
  }

  if (priceLabel) {
    priceLabel.textContent = `$${(variant.price / 100).toFixed(2)}`;
  }
}

        if (quantity) {
          const unavailable = !variant || !variant.available;
          if (quantityControl) {
            quantityControl.hidden = unavailable;
          }

          if (notifyButton) {
            notifyButton.hidden = !unavailable;
          }

          quantity.disabled = unavailable;
          if (minusButton) minusButton.disabled = unavailable;
          if (plusButton) plusButton.disabled = unavailable;

          if (unavailable) {
            quantity.value = 0;
            row.classList.add('multi-size-order-form__size-row--sold-out');
          } else {
            row.classList.remove('multi-size-order-form__size-row--sold-out');
          }
        }
      });
    };
          sizeRows.forEach((row) => {
      const quantity = row.querySelector('[data-multi-size-quantity]');
      const minusButton = row.querySelector('[data-multi-size-minus]');
      const plusButton = row.querySelector('[data-multi-size-plus]');
      

      if (!quantity) return;

         if (minusButton) {
        minusButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const currentValue = parseInt(quantity.value || '0', 10);
          quantity.value = Math.max(0, currentValue - 1);
        });
      }

      if (plusButton) {
  plusButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (quantity.disabled) return;

    const currentValue = parseInt(quantity.value || '0', 10);
    quantity.value = currentValue + 1;
  });
    }
    });
    sizeRows.forEach((row) => {
  const notifyButton = row.querySelector('[data-multi-size-notify]');

  if (!notifyButton) return;

  notifyButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const variantId = notifyButton.dataset.variantId;
    if (!variantId) return;

    klaviyo.openForm('YsrC4B');

    setTimeout(function () {
      const klaviyoFrame = window.frames['klaviyo-bis-iframe'];

      if (
        klaviyoFrame &&
        klaviyoFrame.contentDocument &&
        klaviyoFrame.contentDocument.body
      ) {
        const klaviyoBody = klaviyoFrame.contentDocument.body;
        $(klaviyoBody).find('#variants').val(variantId).change();
      }
    }, 1000);
  });
});
    colorInputs.forEach((input) => {
  input.addEventListener('change', () => {
    updateSizes(input.value);

    const imageVariant = variants.find(
      (item) => item.option1 === input.value && item.featured_media
    );

    const gallery = document.querySelector('product-gallery');

    if (imageVariant && gallery) {
      gallery.showVariantMedia(imageVariant);
    }
  });
});

    const firstColor = colorInputs[0];

    if (firstColor) {
      firstColor.checked = true;
      updateSizes(firstColor.value);
    } else {
      updateSizes();
    }

    if (addToCartButton) {
      addToCartButton.addEventListener('click', () => {
        const items = [];

        sizeRows.forEach((row) => {
          const quantityInput = row.querySelector('[data-multi-size-quantity]');
          const variantId = row.dataset.variantId;
          const quantity = parseInt(quantityInput?.value || '0', 10);

          if (variantId && quantity > 0 && !quantityInput.disabled) {
            items.push({
              id: Number(variantId),
              quantity: quantity
            });
          }
        });

        if (!items.length) return;

const root =
  window.Shopify && Shopify.routes && Shopify.routes.root
    ? Shopify.routes.root
    : '/';

addToCartButton.disabled = true;

fetch(`${root}cart/add.js`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({ items })
})
  .then((response) => {
    if (!response.ok) {
      return response.json().then((error) => {
        throw error;
      });
    }

    return response.json();
  })
  .then((data) => {
  console.log('Multi-size add successful:', data);

  fetch(`${root}cart.js`)
    .then((response) => response.json())
    .then((cart) => {
      window.dispatchEvent(
        new CustomEvent('cartcount:update', {
          detail: cart
        })
      );
    });
})
  .catch((error) => {
    console.error('Multi-size add failed:', error);
  })
  .finally(() => {
    addToCartButton.disabled = false;
  });
      });
    }
  });
});